import { ApplyModule } from '../../store/features/apply/types';
import { SelectedApplyItem } from './types';
import { isProgramApplyItem } from './helper';
import { Box, Button, ButtonProps, Grid, Typography } from '@mui/material';
import { ApplyItemCard } from '../../components/apply-item-card/ApplyItemCard';
import { StrOrNum } from '../../types/util';

interface MassApplyListProps {
  applyItems: SelectedApplyItem[];
  module: ApplyModule;
  toggleSelect: (id: StrOrNum) => void;
  onProgramChange: (programId: StrOrNum | null, scholarshipId: StrOrNum) => void;
  renderApplyBtn: () => React.ReactElement;
  MassApplyEmptyComponent?: React.ReactElement;
  MassApplyHeadingComponent?: React.ReactElement;
  PreviewButtonProps: ButtonProps;
}
export const MassApplyList: React.FC<MassApplyListProps> = ({
  applyItems,
  module,
  onProgramChange,
  toggleSelect,
  renderApplyBtn,
  MassApplyEmptyComponent,
  MassApplyHeadingComponent,
  children,
  PreviewButtonProps,
}) => {
  const moduleTitle = module === 'institute_programs' ? 'Programs' : 'Scholarships';
  const selectedItemIds = applyItems.filter((item) => item.isSelected);

  if (applyItems.length === 0) {
    return (
      MassApplyEmptyComponent || (
        <Box>
          <Typography variant="medium" color="error" fontWeight="Medium">
            No applicable {moduleTitle} has been added yet.
          </Typography>
        </Box>
      )
    );
  }

  return (
    <>
      {MassApplyHeadingComponent}
      <Box sx={{ mb: 4 }}>
        <Grid container alignItems="center" justifyContent="space-between" spacing={1.5}>
          <Grid item>
            <Typography variant="small" color="secondary">
              {selectedItemIds.length > 0
                ? `${selectedItemIds.length} ${moduleTitle} Selected for Apply`
                : `Select ${moduleTitle} for Apply`}
            </Typography>
          </Grid>
          <Grid item>
            <Grid container spacing={1.5}>
              <Grid item>
                <Button {...PreviewButtonProps} variant="default" size="small">
                  Preview
                </Button>
              </Grid>
              <Grid item>{renderApplyBtn()}</Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2.5}>
        {applyItems.map((item) => (
          <Grid key={item.id} item xs={12} md={6} xl={4}>
            <ApplyItemCard
              disabled={
                isProgramApplyItem(item)
                  ? false
                  : item.selectedProgramId
                  ? false
                  : item.programs && item.programs.length > 0
              }
              sx={{ height: 1 }}
              checked={item.isSelected}
              onChange={() => toggleSelect(item.id)}
              applyItem={item}
              ProgramSelectFieldProps={
                isProgramApplyItem(item)
                  ? undefined
                  : {
                      onChange: (_event, option) => onProgramChange(option?.value || null, item.id),
                    }
              }
            />
          </Grid>
        ))}
      </Grid>
      {children}
    </>
  );
};
